



















































































































import Vue from 'vue';
import { State, Getter } from 'vuex-class';
import { Component } from 'vue-property-decorator';

@Component({
  components: {
    ElAvatar: () => import('@/components/parts/ElAvatar.vue'),
    Logo: () => import('@/assets/svg/Logo.svg'),
  },
})
export default class Sidebar extends Vue {
  @Getter('auth', { namespace: 'user' }) auth!: User;
}
